import {
  ADD_PHYSICAL_ART,
  ADD_PHYSICAL_ART_SUCCESS,
  ADD_PHYSICAL_ART_FAIL,
  GET_PHYSICAL_ART_BY_ID,
  GET_PHYSICAL_ART_BY_ID_SUCCESS,
  GET_PHYSICAL_ART_BY_ID_FAIL,
  GET_PHYSICAL_ART_BY_USER_ID,
  GET_PHYSICAL_ART_BY_USER_ID_SUCCESS,
  GET_PHYSICAL_ART_BY_USER_ID_FAIL,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID_SUCCESS,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID_FAIL,
  ADD_PHYSICAL_SELLITEM,
  ADD_PHYSICAL_SELLITEM_SUCCESS,
  ADD_PHYSICAL_SELLITEM_FAIL,
  GET_EXPLORE_PHYSICAL_ART,
  GET_EXPLORE_PHYSICAL_ART_SUCCESS,
  GET_EXPLORE_PHYSICAL_ART_FAIL,
  LIKE_VIEW_PHYSICAL,
  LIKE_VIEW_PHYSICAL_SUCCESS,
  LIKE_VIEW_PHYSICAL_FAIL,
  P_GET_CANVAS_PAPER_SIZE,
  P_GET_CANVAS_PAPER_SIZE_SUCCESS,
  P_GET_CANVAS_PAPER_SIZE_FAIL,
} from "./actionTypes";
const physicalArtReducer = (state = INIT_STATE, action) => {
  console.log("🟠 REDUCER: Action Received", action.type, action.payload);

  switch (action.type) {
    case GET_PHYSICAL_ART_BY_ID:
      console.log("🟡 REDUCER: Starting GET_PHYSICAL_ART_BY_ID");
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PHYSICAL_ART_BY_ID_SUCCESS:
      console.log("🟢 REDUCER: GET_PHYSICAL_ART_BY_ID_SUCCESS", action.payload);
      return {
        ...state,
        loading: false,
        physicalArt: action.payload, // This should store the data
        error: null,
      };

    case GET_PHYSICAL_ART_BY_ID_FAIL:
      console.log("🔴 REDUCER: GET_PHYSICAL_ART_BY_ID_FAIL", action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        physicalArt: {},
      };

    default:
      return state;
  }
};
const INIT_STATE = {
  loading: false,
  error: null,
  // Physical art metadata
  physicalArts: [],
  physicalArt: {},
  physicalArtBySellItem: {},
  // Physical sell items
  physicalSellItem: null,
  physicalListing: [],
  Physical_Printer : {}
};

const PhysicalArt = (state = INIT_STATE, action) => {
  switch (action.type) {
    // ========================= PHYSICAL ART METADATA =========================

    case ADD_PHYSICAL_ART:
      return {
        ...state,
        loading: true,
      };

    case ADD_PHYSICAL_ART_SUCCESS:
      return {
        ...state,
        loading: false,
        physicalArt: action.payload.data || {},
      };

    case ADD_PHYSICAL_ART_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_PHYSICAL_ART_BY_ID:
      return {
        ...state,
        loading: true,
      };

    case GET_PHYSICAL_ART_BY_ID_SUCCESS:
      console.log("🟢 REDUCER: Storing physical art data", action.payload);
      return {
        ...state,
        loading: false,
        physicalArt: action.payload || {},
      };

    case GET_PHYSICAL_ART_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_PHYSICAL_ART_BY_USER_ID:
      return {
        ...state,
        loading: true,
      };

    case GET_PHYSICAL_ART_BY_USER_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        physicalArts: action.payload || [],
      };

    case GET_PHYSICAL_ART_BY_USER_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_PHYSICAL_ART_BY_SELL_ITEM_ID:
      return {
        ...state,
        loading: true,
      };

    case GET_PHYSICAL_ART_BY_SELL_ITEM_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        physicalArtBySellItem: action.payload.data || {},
      };

    case GET_PHYSICAL_ART_BY_SELL_ITEM_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ========================= PHYSICAL ART SELL ITEMS =========================

    case ADD_PHYSICAL_SELLITEM:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_PHYSICAL_SELLITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        physicalSellItem: action.payload,
      };

    case ADD_PHYSICAL_SELLITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_EXPLORE_PHYSICAL_ART:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_EXPLORE_PHYSICAL_ART_SUCCESS:
      return {
        ...state,
        loading: false,
        physicalListing: action.payload,
      };
    case GET_EXPLORE_PHYSICAL_ART_FAIL:
      return {
        ...state,
        loading: false,
        physicalListing: [],
        error: action.payload,
      };
    case P_GET_CANVAS_PAPER_SIZE:
          return {
            ...state,
            loading: true,
          };
    case P_GET_CANVAS_PAPER_SIZE_SUCCESS:
          return {
            ...state,
            loading: false,
            Physical_Printer: action.payload || [],
          };
    case P_GET_CANVAS_PAPER_SIZE_FAIL:
          return {
            ...state,
            loading: false,
            error: action.payload,
          };
      case LIKE_VIEW_PHYSICAL:
            return {
              ...state,
              loading: true,
            };
      
      case LIKE_VIEW_PHYSICAL_SUCCESS:
            return {
              ...state,
              loading: false,
            };
      
      case LIKE_VIEW_PHYSICAL_FAIL:
            return {
              ...state,
              loading: false,
              error: action.payload,
            };

    default:
      return state;
  }
};

export default PhysicalArt;
